import React from "react";
import PublicLayout from "../layout/publicLayout";
import Home from "../component/Home";
import About from "../component/About";
import Contact from "../component/Contact";
import Event from "../component/Event";
import EventDetails from "../component/EventDetails";
import Webinar from "../component/Webinar";
import EPS from "../component/EPS";
import ContentSyndication from "../component/ContentSyndication";
import Pricing from "../component/Pricing";

const Routers = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/services/webinars",
        element: <Webinar />,
      },
      {
        path: "/services/content-syndication",
        element: <ContentSyndication />,
      },
      {
        path: "/services/event-population-service",
        element: <EPS />,
      },
       {
        path: "/services/pricing",
        element: <Pricing />,
      },
      {
        path: "/events",
        element: <Event />,
      },
      {
        path: "/event/:eventUrl",
        element: <EventDetails />,
      },
    ],
  },
];

export default Routers;
